import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_URL_API;

class PaymentCustomerService {
    /**
     *
     * @param token
     * @returns {Promise<AxiosResponse<any>>}
     */
    getPaymentCustomer(token){
        return axios.get(API_URL + 'customer_payments?token=' + token, { headers: authHeader() });
    }

    sendMail(token){
        return axios.post(API_URL + "link/send/mail", {
            token
        },{ headers: authHeader() });
    }
    /**
     *
     * @param customer
     * @param contract
     * @returns {Promise<AxiosResponse<any>>}
     */
    getLinksPayment(customer, contract){
        return axios.post(API_URL + "links/payment", {
            customer,
            contract
        },{ headers: authHeader() });
    }

    /**
     *
     * @param customer
     * @param contract
     * @param amount
     * @param process
     * @param origin
     * @param firstDate
     * @param nbreEtalement
     * @param methodPayment
     * @param methodPaymentSpread
     * @param email
     * @param tel
     * @param sendWith
     * @returns {Promise<AxiosResponse<any>>}
     */
    addPaymentCustomer(customer,
                       contract,
                       amount, process,
                       origin,
                       firstDate,
                       nbreEtalement,
                       methodPayment,
                       methodPaymentSpread,
                       email,
                       tel,
                       backupTel,
                       sendWith,
                       pp1,
                       listRefInvoiceAnticip,
                       force,
                       comment) {
        return axios.post(API_URL + "payment/customer/create", {
            customer,
            contract,
            amount,
            process,
            origin,
            firstDate,
            nbreEtalement,
            methodPayment,
            methodPaymentSpread,
            email,
            tel,
            backupTel,
            sendWith,
            pp1,
            listRefInvoiceAnticip,
            force,
            comment
        },{ headers: authHeader() });
    }

    /**
     *
     * @param customer
     * @param contract
     * @param amount
     * @param process
     * @param origin
     * @param firstDate
     * @param nbreEtalement
     * @param methodPayment
     * @param methodPaymentSpread
     * @param email
     * @param tel
     * @param backupTel
     * @param sendWith
     * @param pp1
     * @param listRefInvoiceAnticip
     * @param force
     * @param comment
     * @returns {Promise<AxiosResponse<any>>}
     */
    addEtalementCustomer(customer,
                       contract,
                       amount, process,
                       origin,
                       firstDate,
                       nbreEtalement,
                       methodPayment,
                       methodPaymentSpread,
                       email,
                       tel,
                       backupTel,
                       sendWith,
                       pp1,
                       listRefInvoiceAnticip,
                       force,
                       comment) {
        return axios.post(API_URL + "etalement/create", {
            customer,
            contract,
            amount,
            process,
            origin,
            firstDate,
            nbreEtalement,
            methodPayment,
            methodPaymentSpread,
            email,
            tel,
            backupTel,
            sendWith,
            pp1,
            listRefInvoiceAnticip,
            force,
            comment
        },{ headers: authHeader() });
    }



    updateDateInvoice(invoice, dateEcheance) {
        return axios.post(API_URL + "energypaid/create/payment_invoice", {
            invoice,
            dateEcheance
        },{ headers: authHeader() });
    }

}

export default new PaymentCustomerService();
